import BreadcrumbList from '../menus/BreadcrumbListComponent'
import { Breadcrumb } from 'types/breadcrumb'

import styles from './BreadcrumbLayout.module.scss'

interface Props {
  menus: Breadcrumb[]
}

const BreadcrumbLayout: React.VFC<Props> = ({ menus }: Props) => {
  return (
    <section className={styles.layout}>
      <div className={styles.layoutContainer}>
        <BreadcrumbList menus={menus} />
      </div>
    </section>
  )
}

export default BreadcrumbLayout
